"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NicplaceMember = function NicplaceMember(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: "fill-primary"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.71,15.43h6.82c-.89-.38-1.93-.76-3.09-1.19l-1.13-.42v-2.2a3.86,3.86,0,0,0,1.37-2.69,2.14,2.14,0,0,0,.08-2.75c.48-1.26,1.09-2.74.83-4C16.28.56,14,0,12.19,0,10.77,0,9.05.36,8.51,1.34A1.72,1.72,0,0,0,7.25,2c-.8,1.08-.25,2.72.14,4.16a2.15,2.15,0,0,0,.07,2.76,3.89,3.89,0,0,0,1.36,2.69v2.2l-1.13.42c-3.18,1.17-5.48,2-6.15,3.36a9.72,9.72,0,0,0-1,3.92A.46.46,0,0,0,1,22h9.68V16.43A1,1,0,0,1,11.71,15.43Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.08,20.55a.37.37,0,0,0-.37.38v2.7a.36.36,0,0,0,.37.37h2.7a.36.36,0,0,0,.37-.37v-2.7a.37.37,0,0,0-.37-.38Z",
    fill: "#f8d60a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.21,20.55a.37.37,0,0,0-.37.38v2.7a.36.36,0,0,0,.37.37h2.7a.37.37,0,0,0,.38-.37v-2.7a.37.37,0,0,0-.38-.38Z",
    fill: "#e4127e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.35,20.55a.37.37,0,0,0-.37.38v2.7a.36.36,0,0,0,.37.37h2.7a.36.36,0,0,0,.37-.37v-2.7a.37.37,0,0,0-.37-.38Z",
    fill: "#94c121"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.08,16.42a.36.36,0,0,0-.37.37v2.7a.36.36,0,0,0,.37.37h2.7a.36.36,0,0,0,.37-.37v-2.7a.36.36,0,0,0-.37-.37Z",
    fill: "#e65016"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.21,16.42a.36.36,0,0,0-.37.37v2.7a.36.36,0,0,0,.37.37h2.7a.37.37,0,0,0,.38-.37v-2.7a.37.37,0,0,0-.38-.37Z",
    fill: "#149cd8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.42,18.14a.26.26,0,0,0-.26-.26H22v-1.2a.26.26,0,1,0-.52,0v1.2H20.23a.26.26,0,0,0,0,.52h1.21v1.21a.26.26,0,0,0,.52,0V18.4h1.2a.26.26,0,0,0,.26-.26",
    fill: "#9d9d9c"
  })));
};

NicplaceMember.propTypes = {};
NicplaceMember.defaultProps = {};
var _default = NicplaceMember;
exports["default"] = _default;